import React from 'react';
import { HiOutlineFolder } from 'react-icons/hi2';
import styles from './Projects.module.css';

const ProjectsEmptyState = ({ activeFilter, onNavigateToEnquiries }) => {
  const getEmptyMessage = () => {
    switch (activeFilter) {
      case 'in_progress':
        return {
          title: 'No projects in progress',
          description: 'Start working on enquiries to see them here.'
        };
      case 'completed':
        return {
          title: 'No completed projects',
          description: 'Completed projects will appear here once marked as done.'
        };
      default:
        return {
          title: 'No active projects yet',
          description: 'Convert enquiries to projects or create new ones to get started.'
        };
    }
  };

  const message = getEmptyMessage();

  return (
    <div className={styles.emptyState}>
      <div className={styles.emptyStateContent}>
        <HiOutlineFolder className={styles.emptyStateIcon} />
        <h3 className={styles.emptyStateTitle}>{message.title}</h3>
        <p className={styles.emptyStateDescription}>
          {message.description}
        </p>
        {activeFilter === 'all' && (
          <button
            onClick={onNavigateToEnquiries}
            className={`${styles.actionButton} ${styles.actionButtonPrimary}`}
            style={{ width: 'auto', padding: 'var(--spacing-s) var(--spacing-xl)' }}
          >
            View Enquiries
          </button>
        )}
      </div>
    </div>
  );
};

export default ProjectsEmptyState;